// extracted by mini-css-extract-plugin
export var editButton = "_ky-0";